import React, { useContext, useState } from "react";
import Dropdown from "../Dropdown";
import { AuthContext } from "../../../../context/AuthContext";
import AddCategoryItemModal from "../AddCategoryItemModal";

const AllergiesSection = ({ allergies, onChange, onAdd, onRemove }) => {
  const { allergiesName, allergiesReaction } = useContext(AuthContext);

  const severityOptions = ["Mild", "Moderate", "Severe"];
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("allergiesName");


  return (
    <div className="space-y-4 border border-slate-200 rounded-lg">
      {/* Table Header */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-slate-100 rounded-lg font-medium">
        <div className="text-xs font-semibold text-slate-700 uppercase tracking-wide">
          Allergen
          <button
            type="button"
            onClick={() => {
              setSelectedCategory("allergiesName");
              setIsOpen(!isOpen)
            }}

            className="ml-2 text-xs text-blue-600 underline">
            add
          </button>
        </div>
        <div className="text-xs font-semibold text-slate-700 uppercase tracking-wide">
          Reaction
          <button
            type="button"
            onClick={() => {
              setSelectedCategory("allergiesReaction");
              setIsOpen(!isOpen)
            }}

            className="ml-2 text-xs text-blue-600 underline">
            add
          </button>
        </div>
        <div className="text-xs font-semibold text-slate-700 uppercase tracking-wide">
          Severity
        </div>
      </div>

      {/* Table Rows */}
      <div className="space-y-2">
        {allergies.map((allergy, idx) => (
          <div
            key={idx}
            className="grid grid-cols-1 md:grid-cols-3 gap-4 p-4 bg-white hover:bg-slate-50 transition-colors"
          >
            <div>
              {/* <input
                type="text"
                placeholder="Enter allergen name"
                value={allergy.allergen}
                onChange={(e) =>
                  onChange("allergies", idx, "allergen", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                aria-label={`Allergy ${idx + 1} Allergen`}
              /> */}
              <Dropdown
                item={"Allergen"} // Change from 'item' to 'selectedUser'
                selectedOption={allergy.allergen}
                onChange={(e) =>
                  onChange("allergies", idx, "allergen", e.target.value)
                }
                listOptions={allergiesName}
              />
            </div>
            <div>
              {/* <input
                type="text"
                placeholder="Enter reaction description"
                value={allergy.reaction}
                onChange={(e) =>
                  onChange("allergies", idx, "reaction", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                aria-label={`Allergy ${idx + 1} Reaction`}
              /> */}
              <Dropdown
                item={"Allergen"} // Change from 'item' to 'selectedUser'
                selectedOption={allergy.reaction}
                onChange={(e) =>
                  onChange("allergies", idx, "reaction", e.target.value)
                }
                listOptions={allergiesReaction}
              />
            </div>
            <div className="flex items-center justify-between">
              {/* <select
                value={allergy.severity}
                onChange={(e) =>
                  onChange("allergies", idx, "severity", e.target.value)
                }
                className="w-full px-3 py-2 text-sm border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                aria-label={`Allergy ${idx + 1} Severity`}
              >
                <option value="" disabled>
                  Select severity
                </option>
                {severityOptions.map((severity) => (
                  <option key={severity} value={severity}>
                    {severity}
                  </option>
                ))}
              </select> */}
              <Dropdown
                item={"Severity"} // Change from 'item' to 'selectedUser'
                selectedOption={allergy.severity}
                onChange={(e) =>
                  onChange("allergies", idx, "severity", e.target.value)
                }
                listOptions={severityOptions}
              />
              <button
                type="button"
                onClick={() => onRemove(idx)}
                className="ml-2 p-1 text-red-500 hover:text-red-700 hover:bg-red-50 rounded transition-colors"
                title="Remove allergy"
                aria-label={`Remove Allergy ${idx + 1}`}
              >
                <svg
                  className="w-4 h-4"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                >
                  <path
                    fillRule="evenodd"
                    d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          </div>
        ))}
      </div>
      <AddCategoryItemModal
        isOpen={isOpen}
        selectedCategory={selectedCategory}
        onClose={() => setIsOpen(false)}
        onAdded=""
      />
    </div>
  );
};

export default AllergiesSection;